import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacySliderChange as MatSliderChange } from '@angular/material/legacy-slider';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { map, Observable } from 'rxjs';
import { ToolbarShadow } from '../../../shared/model';

@UntilDestroy()
@Component({
  selector: 'y42-context-menu-shadow',
  templateUrl: './context-menu-shadow.component.html',
  styleUrls: ['./context-menu-shadow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuShadowComponent {
  constructor(private readonly cd: ChangeDetectorRef) {}

  colorPickerOpened = false;
  isMenuOpen = false;

  readonly _defaultShadow = {
    blur: 0,
    offset: { x: 0, y: 0 },
    color: '#000000',
  };

  get shadowOrDefault(): ToolbarShadow {
    return this.shadow ?? this._defaultShadow;
  }

  @Input()
  @InputObservable()
  public shadow?: ToolbarShadow;
  private readonly shadow$!: Observable<ToolbarShadow>;
  private readonly shadowColor$ = this.shadow$.pipe(
    map((shadow) => (shadow ?? this._defaultShadow).color.toUpperCase()),
  );

  readonly state = connectState(this, {
    shadowColor: this.shadowColor$,
    shadowColorWithoutHash: this.shadowColor$.pipe(map((color) => color.slice(1))),
  });

  @Output()
  shadowChanged = new EventEmitter<ToolbarShadow>();

  onXOffsetChange(x: MatSliderChange) {
    this.shadowChanged.emit({
      ...this.shadowOrDefault,
      offset: {
        ...this.shadowOrDefault.offset,
        x: x.value ?? 0,
      },
    });
  }

  onYOffsetChange(y: MatSliderChange) {
    this.shadowChanged.emit({
      ...this.shadowOrDefault,
      offset: {
        ...this.shadowOrDefault.offset,
        y: y.value ?? 0,
      },
    });
  }

  onBlurChange(blur: MatSliderChange) {
    this.shadowChanged.emit({
      ...this.shadowOrDefault,
      blur: blur.value ?? 0,
    });
  }

  onColorChange(color: string) {
    this.shadowChanged.emit({
      ...this.shadowOrDefault,
      color,
    });
  }

  closeOverlay() {
    // eslint-disable-next-line no-restricted-syntax
    console.trace();
    this.isMenuOpen = false;
    this.cd.markForCheck();
  }
}
